export const SERVICE_MODULE_ROUTE = 'services';
